import { Row } from '@tanstack/react-table';

import intParser from 'utils/intParser';

export const priceFilter = (
  row: Row<any>,
  columnId: string,
  filterValue: any,
): boolean => {
  const { price } = row.original;
  const minPrice = intParser(filterValue[0]);
  const maxPrice = intParser(filterValue[1]);

  // filter empty
  if (!minPrice && !maxPrice) return true;

  // no info about price - hide record.
  if (!price) return false;

  // only minPrice typed
  if (minPrice && !maxPrice) return price >= minPrice;

  // only maxPrice typed
  if (maxPrice && !minPrice) return price <= maxPrice;

  // min & max typed
  return price >= minPrice && price <= maxPrice;
};
